import { useNavigate, useParams, useLocation } from 'react-router';

const ControlPanelButton = () => {
  const { pathwayId, projectId, caseId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname.includes('/control-panel')) {
    return null;
  }

  const handleClick = () => {
    navigate(`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}/control-panel/settings`);
  };

  return (
    <button
      onClick={handleClick}
      className="bg-blue-500 hover:bg-blue-600 text-white rounded px-4 py-1 text-sm font-medium"
    >
      Control Panel
    </button>
  );
};

export default ControlPanelButton;
